import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { forgotPass, resetPass } from "./passResetApi.jsx";

export const forgotPassword = createAsyncThunk(
  "user/forgotPass",
  async (userCredentials) => {
    const response = await forgotPass(userCredentials);
    // console.log(JSON.stringify(response.data))
    let userData = response.data.response.result;
    let Authorization = response.authToken;

    return { userData, Authorization };
  }
);
export const resetPassword = createAsyncThunk(
  "user/resetPass",
  async (userCredentials) => {
    const response = await resetPass(userCredentials);
    return response.data;
  }
);

const passResetSlice = createSlice({
  name: "reset",
  initialState: {
    loading: false,
    Authorization: null,
    UserData: null,
    error: null,
  },
  reducers: {
    updatePassword: (state) => {
      state.loading = false;
      state.Authorization = null;
      state.UserData = null;
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.Authorization = null;
        state.UserData = null;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.Authorization = action.payload.Authorization;
        state.UserData = action.payload.userData;
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.Authorization = null;
        state.UserData = null;
        if (action.error.message === "Request failed with status code 400") {
          state.error = "Access denied!! Invalid Credentials";
        } else {
          state.error = action.error.message;
        }
      });
  },
});
export const { updatePassword } = passResetSlice.actions;

export default passResetSlice.reducer;
